/* eslint-disabled */

export default class AccountExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
